import { Card, Typography, Input } from "antd";
import { FaClock, FaUser, FaShieldAlt, FaPhoneAlt, FaSearch } from "react-icons/fa";
import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";
import { useState } from "react";

const { Text, Title } = Typography;
const { Search } = Input;

export function RecentActivity({ data = [] }) {
  const [searchTerm, setSearchTerm] = useState('');

  const getActivityIcon = (estado, subestado) => {
    if (estado?.toLowerCase().includes("verificado"))
      return {
        icon: <FaShieldAlt className="text-[#009728]" />,
        bg: "rgba(0,151,40,0.08)",
      };
    if (estado?.toLowerCase().includes("llamada"))
      return {
        icon: <FaPhoneAlt className="text-[#0968C6]" />,
        bg: "rgba(9,104,198,0.08)",
      };
    if (estado?.toLowerCase().includes("contact"))
      return {
        icon: <FaPhoneAlt className="text-[#EE8A55]" />,
        bg: "rgba(238,138,85,0.08)",
      };
    return {
      icon: <FaUser className="text-[#97832C]" />,
      bg: "rgba(151,131,44,0.08)",
    };
  };

  const getEstadoColor = (estado) => {
    if (!estado) return '#666';
    const estadoLower = estado.toLowerCase();
    if (estadoLower.includes('verificado')) return '#52c41a';
    if (estadoLower.includes('proceso')) return '#1890ff';
    if (estadoLower.includes('no continúa')) return '#fa8c16';
    if (estadoLower.includes('no verificado')) return '#f5222d';
    return '#666';
  };
  const filteredData = searchTerm
    ? data.filter(item => {
      const term = searchTerm.toLowerCase();
      return (
        (item.nombres && item.nombres.toLowerCase().includes(term)) ||
        (item.apellidos && item.apellidos.toLowerCase().includes(term)) ||
        (item.usuario_id && item.usuario_id.toLowerCase().includes(term)) ||
        (item.estado && item.estado.toLowerCase().includes(term))
      );
    })
    : data;

  return (
    <Card
      hoverable
      style={{
        borderRadius: 12,
        border: "1px solid #e5e7eb",
        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
        background: "#ffffff",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,

          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FaClock size={20} />
          <Title level={5} style={{ margin: 0, color: "#042956", fontWeight: "bold" }}>
            Actividad Reciente
          </Title>
        </div>
        <Search
          placeholder="Buscar nombre, usuario o estado..."
          allowClear
          size="middle"
          style={{ width: 300, minWidth: 200 }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onSearch={setSearchTerm}
          prefix={<FaSearch size={12} />}
        />
      </div>
      {searchTerm && filteredData.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: 20,
          color: '#666',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8
        }}>
          <FaSearch size={24} />
          <div>No se encontraron actividades para "{searchTerm}"</div>
          <button
            type="button"
            onClick={() => setSearchTerm('')}
            style={{
              fontSize: 12,
              background: 'transparent',
              border: 'none',
              padding: 0,
              color: '#1677ff',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
          >
            Ver todas las actividades
          </button>
        </div>
      ) : (
        <>
          <div
            style={{
              maxHeight: 470,
              overflowY: "auto",
              paddingRight: 10,
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            {filteredData.map((item) => {
              const { icon, bg } = getActivityIcon(item.estado, item.subestado);
              const nombreParticipante =
                item.nombres && item.apellidos
                  ? `${item.nombres} ${item.apellidos}`
                  : "Participante";
              return (
                <div
                  key={item.id}
                  style={{
                    display: "flex",
                    gap: 12,
                    paddingBottom: 12,
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <div
                    style={{
                      padding: 20,
                      borderRadius: 10,
                      backgroundColor: bg,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: 40,
                      height: 50,
                      fontSize: 18,
                    }}
                  >
                    {icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <Text style={{ fontSize: 14, color: "#374151" }}>
                      <strong>{item.usuario_id || "Usuario"}</strong>
                      <span style={{ color: "#6b7280", marginLeft: 4 }}>
                        {item.estado ? item.estado.toLowerCase() : "actualizó registro de"}
                      </span>
                    </Text>
                    <Text strong style={{ fontSize: 13, display: 'block', marginTop: 2 }}>
                      {nombreParticipante}
                    </Text>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#9ca3af",
                        marginTop: 4,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <FaClock size={12} />
                        {item.created_at
                          ? formatDistanceToNow(new Date(item.created_at), {
                            addSuffix: true,
                            locale: es,
                          })
                          : "Fecha desconocida"}
                      </div>
                      {item.estado && (
                        <span style={{
                          color: getEstadoColor(item.estado),
                          fontWeight: 500,
                          fontSize: 11
                        }}>
                          {item.estado}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {searchTerm && (
            <div style={{
              marginTop: 12,
              fontSize: 11,
              color: '#666',
              textAlign: 'center',
              paddingTop: 8,
              borderTop: '1px dashed #f0f0f0'
            }}>
              Mostrando {filteredData.length} de {data.length} actividades
              {searchTerm && ` para "${searchTerm}"`}
            </div>
          )}
        </>
      )}
    </Card>
  );
}